import React from 'react';
import './PageLoader.css';

const PageLoader: React.FC = () => {
  return (
    <div className="page-loader">
      <div className="page-loader-content">
        <div className="page-loader-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        <p className="page-loader-text">Loading page...</p>
      </div>
    </div>
  );
};

export default PageLoader;
